import React, { useState, useEffect } from 'react';
import { familyNameService } from '../services/api';
import { useUsers } from '../hooks/useSharedData';
import '../styles/modal.scss';

interface FamilyNameFormModalProps {
  familyName?: { id: number; name: string; headUserId?: number | null } | null;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const FamilyNameFormModal: React.FC<FamilyNameFormModalProps> = ({
  familyName,
  isOpen,
  onClose,
  onSuccess,
}) => {
  const [name, setName] = useState('');
  const [headUserId, setHeadUserId] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { data: users } = useUsers();

  useEffect(() => {
    if (isOpen) {
      setName(familyName?.name || '');
      setHeadUserId(familyName?.headUserId?.toString() || '');
      setError('');
    }
  }, [isOpen, familyName]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      if (familyName) {
        await familyNameService.update(familyName.id, {
          name: name.trim(),
          headUserId: headUserId ? Number(headUserId) : null,
        });
      } else {
        await familyNameService.create({
          name: name.trim(),
          headUserId: headUserId ? Number(headUserId) : null,
        });
      }

      onSuccess();
      onClose();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Đã xảy ra lỗi');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{familyName ? 'Chỉnh sửa dòng họ' : 'Thêm dòng họ mới'}</h2>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="form-group">
              <label htmlFor="familyName">Tên dòng họ *</label>
              <input
                id="familyName"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Nhập tên dòng họ"
                required
              />
            </div>

            {familyName && (
              <div className="form-group">
                <label htmlFor="headUserId">Trưởng họ</label>
                <select
                  id="headUserId"
                  value={headUserId}
                  onChange={(event) => setHeadUserId(event.target.value)}
                >
                  <option value="">Chưa chọn</option>
                  {users
                    .filter((user: any) => !user.isAdmin && user.familyNameId === familyName.id)
                    .map((user: any) => (
                      <option key={user.id} value={user.id}>{user.fullName}</option>
                    ))}
                </select>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-sm"
              onClick={onClose}
              style={{ backgroundColor: '#95a5a6', color: 'white' }}
            >
              Hủy
            </button>
            <button
              type="submit"
              className="btn btn-success btn-sm"
              disabled={isLoading}
            >
              {isLoading ? 'Đang lưu...' : 'Lưu'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
